import createWithBsPrefix from './createWithBsPrefix';
export default createWithBsPrefix('form-file-text', {
  Component: 'span'
});